import React, { useId } from "react";

/**
 * 언어 선택 국기 — 랜딩(`src/pages/landing/LandingPage.jsx` `.lang-list`)의 인라인 SVG 를 그대로 옮겼다.
 * 60×60 viewBox 를 원형으로 자른다. **영어는 영국 국기(유니언 잭)** — 영어는 영국의 언어이므로
 * 성조기를 쓰지 않는다(2026-09-02 대표 지시, `docs/pages/public/Landing.md` 참고).
 *
 * 유니언 잭의 빨간 대각선은 clipPath 로 사분면마다 엇갈리게 배치한다. 한 화면에 국기가 여러 번
 * 그려지므로 clipPath id 는 `useId()` 로 인스턴스마다 다르게 만든다 — 같은 id 가 겹치면
 * 먼저 그려진 쪽 정의를 따라가 국기가 뭉개진다.
 */
export default function LanguageFlag({ lang, size = 21 }) {
  const rawId = useId();
  const clipId = `lang-flag-uk-${rawId.replace(/[^a-zA-Z0-9]/g, "")}`;
  const common = {
    viewBox: "0 0 60 60",
    width: size,
    height: size,
    "aria-hidden": true,
    focusable: "false",
    style: {
      display: "block",
      borderRadius: "50%",
      flex: "none",
      boxShadow: "0 0 0 1px rgba(130,150,152,0.4)",
    },
  };

  if (lang === "ko") {
    return (
      <svg {...common}>
        <rect width="60" height="60" fill="#fff" />
        <circle cx="30" cy="30" r="13.5" fill="#CD2E3A" />
        <path d="M16.5 30a13.5 13.5 0 0 1 27 0 6.75 6.75 0 0 0-13.5 0 6.75 6.75 0 0 1-13.5 0z" fill="#0047A0" />
        <g stroke="#000" strokeWidth="2.1" strokeLinecap="round">
          <path d="M9 14.5l4.6 6.4M12.8 11.8l4.6 6.4" />
          <path d="M46.4 45.7l4.6 6.4M42.6 48.4l4.6 6.4" />
        </g>
      </svg>
    );
  }
  if (lang === "en") {
    return (
      <svg {...common}>
        <defs>
          <clipPath id={clipId}>
            <path d="M30 30h30v30zv30H0zH0V0zV0h30z" />
          </clipPath>
        </defs>
        <rect width="60" height="60" fill="#012169" />
        <path d="M0 0l60 60M60 0L0 60" stroke="#fff" strokeWidth="12" />
        <path d="M0 0l60 60M60 0L0 60" stroke="#C8102E" strokeWidth="8" clipPath={`url(#${clipId})`} />
        <path d="M30 0v60M0 30h60" stroke="#fff" strokeWidth="20" />
        <path d="M30 0v60M0 30h60" stroke="#C8102E" strokeWidth="12" />
      </svg>
    );
  }
  if (lang === "ja") {
    return (
      <svg {...common}>
        <rect width="60" height="60" fill="#fff" />
        <circle cx="30" cy="30" r="15" fill="#BC002D" />
      </svg>
    );
  }
  return (
    <svg {...common}>
      <rect width="60" height="60" fill="#DE2910" />
      <g fill="#FFDE00">
        <path d="M22 15l4.4 13.5-11.5-8.3h14.2l-11.5 8.3z" />
        <path d="M40 14l1.7 5.2-4.4-3.2h5.4l-4.4 3.2zM46 24l1.7 5.2-4.4-3.2h5.4l-4.4 3.2zM40 34l1.7 5.2-4.4-3.2h5.4l-4.4 3.2z" />
      </g>
    </svg>
  );
}
